import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useOrgFilter } from "../scripts/OrgFilterContext";
import { useSocialProfile } from "../scripts/SocialProfileContext";

/**
 * When Circa Social workspace is selected, incomplete profiles are forced to
 * /social/setup. Must wait for workspace bootstrap so default-org users are not
 * briefly treated as Social and stranded on setup.
 */
export default function SocialHardGate({ children }) {
  const { selectedOrgId, workspaceReady } = useOrgFilter();
  const { loading, checked, complete } = useSocialProfile();
  const location = useLocation();
  const isSocial = selectedOrgId === "social";
  const onSetup = location.pathname.startsWith("/social/setup");

  if (!workspaceReady) {
    return (
      <div className="flex items-center justify-center min-h-[40vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!isSocial) {
    if (onSetup) {
      return <Navigate to="/dashboard" replace />;
    }
    return (
      <div className="flex min-h-0 flex-1 flex-col">{children}</div>
    );
  }

  if (loading || !checked) {
    return (
      <div className="flex items-center justify-center min-h-[40vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }
  if (!complete && !onSetup) {
    return <Navigate to="/social/setup" replace />;
  }
  if (complete && onSetup) {
    return <Navigate to="/dashboard" replace />;
  }
  return <div className="flex min-h-0 flex-1 flex-col">{children}</div>;
}
